<template>
  <!-- Rifler -->
  <svg v-if="role === 'rifle'" width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.9548 0.0444983C10.7084 -0.202228 7.97655 0.626596 7.11279 1.31008L9.68993 3.88719C10.3734 3.02311 11.2019 0.291569 10.9548 0.0444983Z" :fill="color" />
    <path d="M5.7736 2.63574L4.88535 2.85763L0.906705 6.8366L0.554898 7.18809L0 7.74298L3.2569 11.0002L3.81214 10.4449L4.16361 10.0931L8.14226 6.11486L8.36449 5.22628C8.36449 5.22628 8.76631 4.82412 9.40111 4.19001L6.81023 1.59944C6.17575 2.23323 5.7736 2.63574 5.7736 2.63574Z" :fill="color" />
  </svg>

  <!-- AWPer -->
  <svg v-else-if="role === 'awp'" width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 0L6.0005 1.531C7.8096 1.75682 9.24345 3.19081 9.46905 5H11V6L9.469 6.0005C9.2432 7.80945 7.80945 9.2432 6.0005 9.469L6 11H5V9.46905C3.19081 9.24345 1.75682 7.8096 1.531 6.0005L0 6V5H1.53095C1.75656 3.19064 3.19064 1.75656 5 1.53095V0H6ZM5.5 4.5C4.9477 4.5 4.5 4.9477 4.5 5.5C4.5 6.0523 4.9477 6.5 5.5 6.5C6.0523 6.5 6.5 6.0523 6.5 5.5C6.5 4.9477 6.0523 4.5 5.5 4.5Z" :fill="color" />
  </svg>

  <!-- Entry -->
  <svg v-else-if="role === 'entry'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 1.5C1.72386 1.5 1.5 1.72386 1.5 2V10C1.5 10.2761 1.72386 10.5 2 10.5H10C10.2761 10.5 10.5 10.2761 10.5 10V2C10.5 1.72386 10.2761 1.5 10 1.5H2ZM5.9998 3.17163L8.97465 6.1465H6.4998V8.8285H5.4998V6.1465H3.0249L5.9998 3.17163Z" :fill="color" />
  </svg>

  <!-- Support -->
  <svg v-else-if="role === 'support'" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.16667 7.77778H5.83333V5.83333H7.77778V4.16667H5.83333V2.22222H4.16667V4.16667H2.22222V5.83333H4.16667V7.77778ZM1.11111 10C0.805556 10 0.543981 9.8912 0.326389 9.67361C0.108796 9.45602 0 9.19444 0 8.88889V1.11111C0 0.805556 0.108796 0.543981 0.326389 0.326389C0.543981 0.108796 0.805556 0 1.11111 0H8.88889C9.19444 0 9.45602 0.108796 9.67361 0.326389C9.8912 0.543981 10 0.805556 10 1.11111V8.88889C10 9.19444 9.8912 9.45602 9.67361 9.67361C9.45602 9.8912 9.19444 10 8.88889 10H1.11111Z" :fill="color" />
  </svg>

  <!-- Lurker — eye/stealth icon -->
  <svg v-else-if="role === 'lurker'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 2.5C3.5 2.5 1.365 4.015 0.5 6C1.365 7.985 3.5 9.5 6 9.5C8.5 9.5 10.635 7.985 11.5 6C10.635 4.015 8.5 2.5 6 2.5ZM6 8.5C4.62 8.5 3.5 7.38 3.5 6C3.5 4.62 4.62 3.5 6 3.5C7.38 3.5 8.5 4.62 8.5 6C8.5 7.38 7.38 8.5 6 8.5ZM6 4.5C5.17 4.5 4.5 5.17 4.5 6C4.5 6.83 5.17 7.5 6 7.5C6.83 7.5 7.5 6.83 7.5 6C7.5 5.17 6.83 4.5 6 4.5Z" :fill="color" />
  </svg>

  <!-- Pistol — handgun icon -->
  <svg v-else-if="role === 'pistol'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.00244 9.5H11.0025V10.5H1.00244V9.5ZM1.00244 2.5L3.50244 4L6.00245 1L8.50245 4L11.0025 2.5V8.5H1.00244V2.5Z" :fill="color" />
  </svg>
</template>

<script setup>
defineProps({
  role: { type: String, required: true },
  color: { type: String, required: true },
});
</script>
